export const LocalStorage = (context) => ({
    set(key, value) {
        localStorage.setItem(`${context}-${key}`, JSON.stringify(value));
    },
    get(key) {
        return JSON.parse(localStorage.getItem(`${context}-${key}`))
    }
})